import React from "react";
import MarkdownIt from "markdown-it";
import parse from 'html-react-parser';
import anchor from "markdown-it-anchor";
import licenseDoc from "../assets/user_license.md";

export class DownloadPage extends React.Component{
    constructor(){
        super();
        this.state = {
            licenseDoc:"Loading..."
        }
    }
    componentDidMount(){
        window.scrollTo(0, 0);
        fetch(licenseDoc)
        .then((r) => r.text())
        .then(text  => {
            const md=MarkdownIt({html:true});
            md.use(anchor, {
                permalink: anchor.permalink.headerLink()
            })
            const res = md.render(text);
            this.setState((prevState)=>{
                return {
                    ...prevState,
                    licenseDoc:res
                }
            })
        })
    }
    clickDownload(){
        alert("施工中...(◔◡◔)")
    }
    render(){
        return (
            <div className="feature-page-container">
                <div className="markdown-body-container">
                    <div className="markdown-container">
                        {parse(this.state.licenseDoc)}     
                    </div>
                </div>
                <button className="download-button" onClick={this.clickDownload}>Download</button>
            </div>
        )
    }
}